import { Badge, Icon } from '@chakra-ui/react'
import {
  faGear,
  faGlobe,
  faUser,
  faUserGroup,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import { getUserTypeName, UserType } from 'BrokerTsLib/src/enums'

export const UserTypeBadge = ({ type }: { type: UserType }) => (
  <Badge
    colorScheme="blue"
    width={'fit-content'}
    gap={1}
    display={'flex'}
    alignItems={'center'}
    fontWeight={'medium'}
    py={0.5}
    px={1.5}
  >
    <CustomTooltip label={getUserTypeName(type)} hasArrow>
      <Icon
        as={FontAwesomeIcon}
        icon={getUserTypeIcon(type)}
        boxSize={3}
        color="blue.600"
      />
    </CustomTooltip>
  </Badge>
)

const getUserTypeIcon = (type: UserType) => {
  switch (type) {
    case UserType.ApplicationUser:
      return faUser
    case UserType.ApiUser:
      return faGlobe
    case UserType.ActiveDirectoryUser:
      return faUserGroup
    case UserType.WsUser:
      return faGear
  }
}
